import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "py-2 px-1 flex"
};
const _hoisted_2 = {
  key: 0,
  class: "text-gray-400"
};
const _hoisted_3 = {
  class: "bg-[rgba(var(--v-theme-error),0.08)] flex flex-row py-2 px-1"
};
const _hoisted_4 = {
  class: "w-11/12 py-2 text-error"
};
import LlSwitch from '@/components/LlSwitch.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { onMounted, reactive } from 'vue';
export default {
  __name: 'EmailSidebar',
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const emailSidebar = reactive({
      me: {}
    });
    const meStore = useMeStore();
    onMounted(async () => {
      emailSidebar.me = await meStore.getMe();
    });
    const goToConfidoIntegration = () => {
      props.state.routeService.go('settings.company.integrations');
    };
    async function selectItemsToggle(module) {
      if (module.state.toLowerCase() === 'comingsoon' || props.state.reminderMode === '2') return;
      if (disableOnGravityDisabled(module)) {
        props.state.showGravityWarning = true;
        return;
      }
      if (module.id === 9) {
        if (!emailSidebar.me.features.expenseAttachments) {
          props.state.showUpgradeToProExpenseAttachmentsModals = true;
          return;
        }
        props.state.showExpenseWarning = true;
      } else {
        props.state.selectItemsChanged = true;
        module.enabled = !module.enabled;
      }
    }
    const disableOnGravityDisabled = module => {
      if ((module.id == 1 || module.id == 8) && !module.enabled && !props.state.me?.company?.settings?.gravity?.enabled) {
        return true;
      }
      return false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("span", {
        class: ""
      }, [_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M3.5 17C3.08333 17 2.72917 16.8542 2.4375 16.5625C2.14583 16.2708 2 15.9167 2 15.5V8.5C2 8.08333 2.14583 7.72917 2.4375 7.4375C2.72917 7.14583 3.08333 7 3.5 7H20.5C20.9167 7 21.2708 7.14583 21.5625 7.4375C21.8542 7.72917 22 8.08333 22 8.5V15.5C22 15.9167 21.8542 16.2708 21.5625 16.5625C21.2708 16.8542 20.9167 17 20.5 17H18.9V15.5H20.5V8.5H3.5V15.5H10.1V17H3.5ZM14.5 19L13.6 17L11.6 16.1L13.6 15.2L14.5 13.2L15.4 15.2L17.4 16.1L15.4 17L14.5 19ZM17 13.7L16.475 12.525L15.3 12L16.475 11.475L17 10.3L17.525 11.475L18.7 12L17.525 12.525L17 13.7Z",
        fill: "#2A9811"
      })])], -1)), _createElementVNode("span", {
        class: _normalizeClass(["pl-2 text-green-regular text-base", {
          'text-gray-400': __props.state.reminderMode === '2'
        }])
      }, "Select Items", 2)], 512), [[_vShow, __props.state.reminderMode !== '2']]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.state.modules, (moduleState, idx) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "flex py-1",
          key: idx
        }, [_createVNode(LlSwitch, {
          "model-value": moduleState.enabled,
          disabled: __props.state?.reminderMode === '2' || disableOnGravityDisabled(moduleState) && __props.state.showGravityWarning,
          "onUpdate:modelValue": $event => selectItemsToggle(moduleState)
        }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]), _createElementVNode("div", {
          class: _normalizeClass(["py-1 px-1", {
            'text-gray-400': __props.state.reminderMode === '2'
          }])
        }, [_createTextVNode(_toDisplayString(moduleState.name) + " ", 1), moduleState.state.toLowerCase() === 'comingsoon' ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(Coming Soon)")) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(["py-1 px-1", {
            'text-error': disableOnGravityDisabled(moduleState) && __props.state.showGravityWarning
          }])
        }, null, 2)], 2)])), [[_vShow, __props.state.reminderMode !== '2']]);
      }), 128)), _withDirectives(_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "fa fa-exclamation-circle fa-2 text-error px-1 py-3 w-1/12"
      }, null, -1)), _createElementVNode("span", _hoisted_4, [_cache[2] || (_cache[2] = _createTextVNode(" You need an active Confido Legal account, our payments partner, to enable this feature. Please click ", -1)), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => goToConfidoIntegration(), ["prevent"])),
        class: "cursor-pointer underline"
      }, "here "), _cache[3] || (_cache[3] = _createTextVNode(" to get set up or reconnected. ", -1))])], 512), [[_vShow, __props.state.showGravityWarning]])], 64);
    };
  }
};